export interface iLogin {
    'chave': string;
    'senha': string;
    'escopo': string;
}

export class Usuario {
    'userData': userData;
    'access_token': string;
    'token_type': string;
    'expires_in': string;
    'refresh_token': string;
    'scope': string;
    'emitido_em': string;
    'data_expiracao': string;
    'chave': string;
}

export class userData {
    'tipoUsuario': string; /* 1 = Usuário de aplicação (repositório próprio); 
                              2 = Usuário externo (repositório = MCI que representa); 
                              3 = Usuário interno (repositório = UOR(s) que representa); */
    'userAplicacao': userAplicacao;
    'userExterno': userExterno;
    'userInterno': userInterno;
}

export class userAplicacao {
    'username': string;
    'codUserAplicacao': string;
    'versaoUserAplicacao': string;
    'repositorio': string[];
}

export class userAutorizador {
    'username': string;
    'descricao': string;
    'nomeCertificadoVinculado': string;
    'codMciVinc': number;
    'codUorVinc': number;
    'qtdMinGeracaoAlarmeSia': number;
    'timeStampUltConexaoSia': string;
    'msgAlarmeSia': string;
    'obsAlteracao': string;
    'senha': string;
}

export class userExterno {
    'username': string;
    'userImpessoal': boolean;
    'mci': string;
}

export class userInterno {
    'username': string;
    'userImpessoal': boolean;
    'uor': string[];
}

export class UsuarioPesquisa {
    'codUsuario': string;
    'vrsUsuario': string;
    'username': string;
    'descricao': string;
    'nomeCertificadoVinculado': string;
    'codMciVinc': any;
    'codUorVinc': any;
    'qtdMinGeracaoAlarmeSia': number;
    'timeStampUltConexaoSia': string;
    'msgAlarmeSia': string;
    'obsAlteracao': string;
    'senha': string;
    'acoes': string;
    'escopos': Array<Escopos>;
}

export class Escopos {
    'codEscopo': string;
    'nmEscopo': string;


}

export class VincularEscopos {
    'codUsuario': number;
    'vrsUsuario': number;
    escopos: Array<Escopo> = new Array<Escopo>();

}


export class Escopo {
    'codEscopo': number;
}

export class UsuarioRetorno {
    'codigo': number;
    'versao': number;
}



// WEBPACK FOOTER //
// ./src/model/usuario.ts